import template from './ko-field-input-text.html';

class TextInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable(params.readonly ?? false);
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.multiline = ko.observable(false);
		this.rows = ko.observable();
		this.auto_select = ko.observable(params.ui_fields?.auto_select ?? params.auto_select ?? false);
		this.help_text = ko.observable(params.help_text);

		if (params.ui_fields)
		{
			this.multiline(params.ui_fields.multiline);
			this.rows(params.ui_fields.rows);
		}
		else
		{
			if (params.rows)
				this.rows(params.rows);
			if (params.multiline)
				this.multiline(params.multiline);
		}
	}
}


export default {
	name: 'ko-field-input-text',
	viewModel: TextInputComponentVM,
	module_type: 'ko',
	template: template
}
